(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1629,8279,4829],{

/***/ 7573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);



var server = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
  baseURL: "https://mu7.ejjadh.info"
});
server.interceptors.response.use(function (response) {
  return response;
}, /*#__PURE__*/function () {
  var _ref = (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(error) {
    var _error$response;

    var config;
    return _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = error.config;

            if (config) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", Promise.reject(error));

          case 3:
            config.__retryCount = config.__retryCount || 0;

            if (!(((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 429 && config.__retryCount < 3)) {
              _context.next = 10;
              break;
            }

            config.__retryCount++;
            console.log("429 received. Retry ".concat(config.__retryCount, "/3 for ").concat(config.url));
            _context.next = 9;
            return new Promise(function (r) {
              return setTimeout(r, 15000);
            });

          case 9:
            return _context.abrupt("return", server(config));

          case 10:
            return _context.abrupt("return", Promise.reject(error));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
/* harmony default export */ __webpack_exports__["Z"] = (server);

/***/ }),

/***/ 4829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7794);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _shared_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8122);
/* harmony import */ var _Form_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5115);
/* harmony import */ var _Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_Form_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7536);
/* harmony import */ var _api_server__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7573);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4012);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4215);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1555);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












function Form() {
  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(),
      locale = _useRouter.locale;

  var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      formSubmitted = _useState[0],
      setFormSubmitted = _useState[1];

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_8__/* .useForm */ .cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors,
      reset = _useForm.reset;

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(data) {
      var res;
      return _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _api_server__WEBPACK_IMPORTED_MODULE_4__/* ["default"].post */ .Z.post("/api/contact", data);

            case 3:
              res = _context.sent;

              if (res.data.status === "success") {
                setFormSubmitted(true);
                reset();
                setTimeout(function () {
                  setFormSubmitted(false);
                }, 3000);
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error("Form submission failed", _context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var isRtl = locale === "ar";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("form", {
    className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default().form),
    onSubmit: handleSubmit(onSubmit),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["contact-box"]),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h3", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            id: "have-question"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            id: "have-question-desc"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__["default"], {
        dir: locale === "ar" ? "rtl" : "ltr",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__["default"], {
          xs: 12,
          md: 6,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["input-group"]),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                id: "name"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("input", _objectSpread(_objectSpread({}, register("name", {
              required: intl.formatMessage({
                id: "required"
              }),
              minLength: {
                value: 2,
                message: intl.formatMessage({
                  id: "min-length"
                })
              }
            })), {}, {
              placeholder: intl.formatMessage({
                id: "name"
              }),
              type: "text"
            })), errors.name && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["error-text"]),
              children: errors.name.message
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__["default"], {
          xs: 12,
          md: 6,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["input-group"]),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                id: "last"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("input", _objectSpread(_objectSpread({}, register("last_name", {
              required: intl.formatMessage({
                id: "required"
              }),
              minLength: {
                value: 2,
                message: intl.formatMessage({
                  id: "min-length"
                })
              }
            })), {}, {
              placeholder: intl.formatMessage({
                id: "last"
              }),
              type: "text"
            })), errors.last_name && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["error-text"]),
              children: errors.last_name.message
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__["default"], {
          xs: 12,
          md: 6,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["input-group"]),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                id: "phone"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("input", _objectSpread(_objectSpread({}, register("phone", {
              required: intl.formatMessage({
                id: "required"
              }),
              pattern: {
                value: /^\d+$/,
                message: intl.formatMessage({
                  id: "invalid-phone"
                })
              },
              minLength: {
                value: 8,
                message: intl.formatMessage({
                  id: "min-length"
                })
              }
            })), {}, {
              placeholder: intl.formatMessage({
                id: "phone"
              })
            })), errors.phone && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["error-text"]),
              children: errors.phone.message
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__["default"], {
          xs: 12,
          md: 6,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["input-group"]),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                id: "mail"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("input", _objectSpread(_objectSpread({}, register("email", {
              required: intl.formatMessage({
                id: "required"
              }),
              pattern: {
                value: /^\S+@\S+\.\S+$/,
                message: intl.formatMessage({
                  id: "invalid-email"
                })
              },
              minLength: {
                value: 8,
                message: intl.formatMessage({
                  id: "min-length"
                })
              }
            })), {}, {
              placeholder: intl.formatMessage({
                id: "mail"
              }),
              type: "email"
            })), errors.email && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["error-text"]),
              children: errors.email.message
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__["default"], {
          xs: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["input-group"]),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                id: "massage"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("textarea", _objectSpread(_objectSpread({}, register("massage", {
              required: intl.formatMessage({
                id: "required"
              })
            })), {}, {
              placeholder: intl.formatMessage({
                id: "massage"
              }),
              cols: "100",
              rows: "5"
            })), errors.massage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["error-text"]),
              children: errors.massage.message
            })]
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["button-wrapper"]),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("button", {
          type: "submit",
          className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["cta-button-red"]),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            id: "contact-us"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["icon-circle"]),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("svg", {
              style: {
                transform: isRtl ? "none" : "scaleX(-1)"
              },
              width: "18",
              height: "18",
              viewBox: "0 0 18 18",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                d: "M3.53577 3.53556L14.1424 14.1422",
                stroke: "black",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                stroke: "black",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
              })]
            })
          })]
        })
      }), formSubmitted && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("strong", {
        className: "mt-4 d-block text-center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          id: "form-message"
        })
      })]
    })
  });
}

/***/ }),

/***/ 8122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1215);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Button_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





function Button(_ref) {
  var _classNames;

  var buttonColor = _ref.buttonColor,
      buttonText = _ref.buttonText,
      buttonShape = _ref.buttonShape,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var wrapperClasses = classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().button)], (_classNames = {}, (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().red), buttonColor === "red"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().black), buttonColor === "black"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().rounded), buttonShape === "round"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().squared), buttonShape === "square"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().disabled), disabled), _classNames));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
    onClick: onClick,
    className: wrapperClasses,
    disabled: disabled,
    children: buttonText
  });
}

/***/ }),

/***/ 38:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f8": function() { return /* binding */ buildApiUrl; }
/* harmony export */ });
/* unused harmony exports getImageUrl, validateImageUrl, getImageDimensions */
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);


var buildApiUrl = function buildApiUrl(path) {
  if (!path) return "";

  try {
    new URL(path);
    return path;
  } catch (_unused) {
    var base = "https://mu7.ejjadh.info" || 0;
    var sep = path.startsWith("/") ? "" : "/";
    return "".concat(base).concat(sep).concat(path);
  }
}; // Helper function to ensure valid image URLs and proper error handling

var getImageUrl = function getImageUrl(path) {
  if (!path) return null;

  try {
    // If it's already a full URL, return it
    new URL(path);
    return path;
  } catch (_unused2) {
    // If it's a relative path, prepend the API URL
    return buildApiUrl(path);
  }
}; // Helper function to validate image

var validateImageUrl = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(url, {
              method: "HEAD"
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.ok);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", false);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function validateImageUrl(_x) {
    return _ref.apply(this, arguments);
  };
}())); // Helper function to get proper image dimensions

var getImageDimensions = function getImageDimensions() {
  var imageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
  var dimensions = {
    "default": {
      width: 800,
      height: 600
    },
    thumbnail: {
      width: 150,
      height: 150
    },
    banner: {
      width: 1920,
      height: 1080
    },
    profile: {
      width: 300,
      height: 300
    }
  };
  return dimensions[imageType] || dimensions["default"];
};

/***/ }),

/***/ 6831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HomePage_HomePage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/modules/HomePage/HomePage.module.scss
var HomePage_module = __webpack_require__(4471);
var HomePage_module_default = /*#__PURE__*/__webpack_require__.n(HomePage_module);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./public/logo.png
var logo = __webpack_require__(3476);
// EXTERNAL MODULE: ./src/assets/images/second-bg.png
var second_bg = __webpack_require__(292);
;// CONCATENATED MODULE: ./src/assets/images/forth-bg.png
/* harmony default export */ var forth_bg = ({"src":"/_next/static/media/forth-bg.47f7bf1b.png","height":785,"width":1047,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAABlBMVEXy8vL////jGPreAAAAAnRSTlMpJuDY1y4AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAOSURBVHicY2AgBTBCAQAAWgAJV+kNkQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.min.css
var bootstrap_min = __webpack_require__(8210);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.css
var aos = __webpack_require__(8279);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/react-before-after-slider-component/dist/build.js
var build = __webpack_require__(477);
// EXTERNAL MODULE: ./node_modules/react-before-after-slider-component/dist/build.css
var dist_build = __webpack_require__(2357);
// EXTERNAL MODULE: ./src/components/ContacUsPage/Form/Form.jsx
var Form = __webpack_require__(4829);
// EXTERNAL MODULE: ./src/helpers/imageHelpers.js
var imageHelpers = __webpack_require__(38);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(2873);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(8116);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(8770);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/modules/HomePage/HomePage.jsx




 // Optimize image imports




var WhiteBackground = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 632).then(__webpack_require__.bind(__webpack_require__, 632));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (HomePage_module_default()).imagePlaceholder
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(632)];
    }
  }
}); // Optimize bootstrap imports

var Container = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 682).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});
var Row = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4215));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4215)];
    }
  }
});
var Col = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1555));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1555)];
    }
  }
});
var Modal = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4651).then(__webpack_require__.bind(__webpack_require__, 4651));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4651)];
    }
  }
}); // Import styles after component mount


 // components

var Spliter = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9245).then(__webpack_require__.bind(__webpack_require__, 9245));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9245)];
    }
  }
});
var Testmonials = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 347).then(__webpack_require__.bind(__webpack_require__, 347));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(347)];
    }
  }
});
var NavigationBar = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9477), __webpack_require__.e(4208), __webpack_require__.e(128)]).then(__webpack_require__.bind(__webpack_require__, 4208));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4208)];
    }
  }
});
var BackgroundImageWithTextButtonRightImageLeft = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5148).then(__webpack_require__.bind(__webpack_require__, 5148));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(5148)];
    }
  }
});
var BackgroundImageWithRightTextLeftButton = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 8237).then(__webpack_require__.bind(__webpack_require__, 8237));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8237)];
    }
  }
});
var PriceList = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 3565).then(__webpack_require__.bind(__webpack_require__, 3565));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(3565)];
    }
  }
});
var Carousel = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9534).then(__webpack_require__.bind(__webpack_require__, 9534));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9534)];
    }
  }
});
var Footer = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7148), __webpack_require__.e(3063)]).then(__webpack_require__.bind(__webpack_require__, 7148));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7148)];
    }
  }
});
var CommonQuestions = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1803).then(__webpack_require__.bind(__webpack_require__, 1868));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1868)];
    }
  }
});















var HomePage = function HomePage(_ref) {
  var _data$indexData, _data$galleryData, _data$galleryData$, _data$galleryData$$ca, _data$galleryData$$ca2, _data$partnerData, _data$partnerData$, _data$partnerData$$ca, _data$partnerData$$ca2, _data$bannerData, _data$bannerData$, _data$bannerData$$cat, _data$bannerData$$cat2, _data$benfitDataPosts, _data$benfitDataPosts2, _data$benfitDataPosts3, _data$benfitDataPosts4, _data$benfitDataHeade, _data$benfitDataHeade2, _data$benfitDataHeade3, _data$benfitDataHeade4, _data$splitersData, _data$splitersData$, _data$splitersData$$c, _data$splitersData$$c2, _data$testmonialsData, _data$testmonialsData2, _data$testmonialsData3, _data$testmonialsData4, _data$pricesData, _data$pricesData$, _data$pricesData$$cat, _data$questions, _data$questions$, _data$questions$$cate, _data$questions$$cate2, _certificationsPost$d, _certificationsPost$d2, _certificationsPost$d3, _targetQuestion$data, _footerSettings$AppSe, _appSetting$mainBanne, _data$indexData2, _data$indexData2$AppS, _data$indexData3, _data$indexData3$AppS, _data$indexData4, _data$indexData4$AppS, _data$indexData5, _data$indexData5$AppS, _splitersData$, _splitersData$$data, _splitersData$$data$t, _splitersData$2, _splitersData$2$data, _splitersData$2$data$, _splitersData$3, _splitersData$3$data, _splitersData$3$data$, _splitersData$4, _splitersData$4$data, _splitersData$4$data$, _splitersData$5, _splitersData$5$data, _data$sliderData, _data$sliderData$, _data$sliderData$$cat, _data$sliderData$$cat2;

  var data = _ref.data,
      appSetting = _ref.appSetting,
      footerSettings = _ref.footerSettings;
  var indexData = data === null || data === void 0 ? void 0 : (_data$indexData = data.indexData) === null || _data$indexData === void 0 ? void 0 : _data$indexData.AppSetting;
  var galleryPosts = data === null || data === void 0 ? void 0 : (_data$galleryData = data.galleryData) === null || _data$galleryData === void 0 ? void 0 : (_data$galleryData$ = _data$galleryData[0]) === null || _data$galleryData$ === void 0 ? void 0 : (_data$galleryData$$ca = _data$galleryData$.categories) === null || _data$galleryData$$ca === void 0 ? void 0 : (_data$galleryData$$ca2 = _data$galleryData$$ca[0]) === null || _data$galleryData$$ca2 === void 0 ? void 0 : _data$galleryData$$ca2.posts;
  var partnerPosts = data === null || data === void 0 ? void 0 : (_data$partnerData = data.partnerData) === null || _data$partnerData === void 0 ? void 0 : (_data$partnerData$ = _data$partnerData[0]) === null || _data$partnerData$ === void 0 ? void 0 : (_data$partnerData$$ca = _data$partnerData$.categories) === null || _data$partnerData$$ca === void 0 ? void 0 : (_data$partnerData$$ca2 = _data$partnerData$$ca[0]) === null || _data$partnerData$$ca2 === void 0 ? void 0 : _data$partnerData$$ca2.posts;
  var bannerData = data === null || data === void 0 ? void 0 : (_data$bannerData = data.bannerData) === null || _data$bannerData === void 0 ? void 0 : (_data$bannerData$ = _data$bannerData[0]) === null || _data$bannerData$ === void 0 ? void 0 : (_data$bannerData$$cat = _data$bannerData$.categories) === null || _data$bannerData$$cat === void 0 ? void 0 : (_data$bannerData$$cat2 = _data$bannerData$$cat[0]) === null || _data$bannerData$$cat2 === void 0 ? void 0 : _data$bannerData$$cat2.posts;
  var benfitDataPosts = data === null || data === void 0 ? void 0 : (_data$benfitDataPosts = data.benfitDataPosts) === null || _data$benfitDataPosts === void 0 ? void 0 : (_data$benfitDataPosts2 = _data$benfitDataPosts[0]) === null || _data$benfitDataPosts2 === void 0 ? void 0 : (_data$benfitDataPosts3 = _data$benfitDataPosts2.categories) === null || _data$benfitDataPosts3 === void 0 ? void 0 : (_data$benfitDataPosts4 = _data$benfitDataPosts3[0]) === null || _data$benfitDataPosts4 === void 0 ? void 0 : _data$benfitDataPosts4.posts;
  var benfitDataHeader = data === null || data === void 0 ? void 0 : (_data$benfitDataHeade = data.benfitDataHeader) === null || _data$benfitDataHeade === void 0 ? void 0 : (_data$benfitDataHeade2 = _data$benfitDataHeade[0]) === null || _data$benfitDataHeade2 === void 0 ? void 0 : (_data$benfitDataHeade3 = _data$benfitDataHeade2.categories) === null || _data$benfitDataHeade3 === void 0 ? void 0 : (_data$benfitDataHeade4 = _data$benfitDataHeade3[0]) === null || _data$benfitDataHeade4 === void 0 ? void 0 : _data$benfitDataHeade4.posts;
  var splitersData = data === null || data === void 0 ? void 0 : (_data$splitersData = data.splitersData) === null || _data$splitersData === void 0 ? void 0 : (_data$splitersData$ = _data$splitersData[0]) === null || _data$splitersData$ === void 0 ? void 0 : (_data$splitersData$$c = _data$splitersData$.categories) === null || _data$splitersData$$c === void 0 ? void 0 : (_data$splitersData$$c2 = _data$splitersData$$c[0]) === null || _data$splitersData$$c2 === void 0 ? void 0 : _data$splitersData$$c2.posts; // const videoData = data?.videoData?.[0]?.categories?.[0]?.posts;

  var testmonialsData = data === null || data === void 0 ? void 0 : (_data$testmonialsData = data.testmonialsData) === null || _data$testmonialsData === void 0 ? void 0 : (_data$testmonialsData2 = _data$testmonialsData[0]) === null || _data$testmonialsData2 === void 0 ? void 0 : (_data$testmonialsData3 = _data$testmonialsData2.categories) === null || _data$testmonialsData3 === void 0 ? void 0 : (_data$testmonialsData4 = _data$testmonialsData3[0]) === null || _data$testmonialsData4 === void 0 ? void 0 : _data$testmonialsData4.posts;
  var pricesData = data === null || data === void 0 ? void 0 : (_data$pricesData = data.pricesData) === null || _data$pricesData === void 0 ? void 0 : (_data$pricesData$ = _data$pricesData[0]) === null || _data$pricesData$ === void 0 ? void 0 : (_data$pricesData$$cat = _data$pricesData$.categories) === null || _data$pricesData$$cat === void 0 ? void 0 : _data$pricesData$$cat[0];
  var questionsData = data === null || data === void 0 ? void 0 : (_data$questions = data.questions) === null || _data$questions === void 0 ? void 0 : (_data$questions$ = _data$questions[0]) === null || _data$questions$ === void 0 ? void 0 : (_data$questions$$cate = _data$questions$.categories) === null || _data$questions$$cate === void 0 ? void 0 : (_data$questions$$cate2 = _data$questions$$cate[0]) === null || _data$questions$$cate2 === void 0 ? void 0 : _data$questions$$cate2.posts;
  var router = (0,next_router.useRouter)();
  var lang = router.locale;
  var certificationsPost = data === null || data === void 0 ? void 0 : data.certificationsPost;
  var certificationsTitle = certificationsPost === null || certificationsPost === void 0 ? void 0 : (_certificationsPost$d = certificationsPost.data) === null || _certificationsPost$d === void 0 ? void 0 : (_certificationsPost$d2 = _certificationsPost$d.title) === null || _certificationsPost$d2 === void 0 ? void 0 : _certificationsPost$d2[lang];
  var certificationsItems = (certificationsPost === null || certificationsPost === void 0 ? void 0 : (_certificationsPost$d3 = certificationsPost.data) === null || _certificationsPost$d3 === void 0 ? void 0 : _certificationsPost$d3.certifications) || [];

  var _useState = (0,react.useState)(null),
      lightboxImage = _useState[0],
      setLightboxImage = _useState[1];

  var dir = lang === "ar" ? "rtl" : "ltr";
  var isRtl = lang === "ar";
  var targetQuestion = questionsData === null || questionsData === void 0 ? void 0 : questionsData.find(function (question) {
    return question.id === 416;
  });
  var commonQuestionsBackgroundImage = targetQuestion === null || targetQuestion === void 0 ? void 0 : (_targetQuestion$data = targetQuestion.data) === null || _targetQuestion$data === void 0 ? void 0 : _targetQuestion$data.image;
  var filteredQuestions = questionsData === null || questionsData === void 0 ? void 0 : questionsData.filter(function (question) {
    return question.id !== 416;
  });
  var resolvedAppSetting = appSetting || indexData;

  var normalizeSettingValue = function normalizeSettingValue(value) {
    return typeof value === "string" ? value.replace(/`/g, "").trim() : "";
  };

  var bannerCtaText = normalizeSettingValue(lang === "ar" ? resolvedAppSetting === null || resolvedAppSetting === void 0 ? void 0 : resolvedAppSetting.mainBannerCtaText : (resolvedAppSetting === null || resolvedAppSetting === void 0 ? void 0 : resolvedAppSetting.mainBannerCtaText_EN) || (resolvedAppSetting === null || resolvedAppSetting === void 0 ? void 0 : resolvedAppSetting.mainBannerCtaText));
  var bannerCtaUrl = normalizeSettingValue(resolvedAppSetting === null || resolvedAppSetting === void 0 ? void 0 : resolvedAppSetting.mainBannerCtaUrl);
  var isExternalBannerCtaUrl = /^https?:\/\//i.test(bannerCtaUrl);
  var contactMapHtml = (footerSettings === null || footerSettings === void 0 ? void 0 : (_footerSettings$AppSe = footerSettings.AppSetting) === null || _footerSettings$AppSe === void 0 ? void 0 : _footerSettings$AppSe.ifameMap) || (indexData === null || indexData === void 0 ? void 0 : indexData.ifameMap) || "";
  var contactFallbackImage = (resolvedAppSetting === null || resolvedAppSetting === void 0 ? void 0 : resolvedAppSetting.fullbackMapImage) || (indexData === null || indexData === void 0 ? void 0 : indexData.fullbackMapImage) || "";
  var hasContactMap = Boolean(contactMapHtml === null || contactMapHtml === void 0 ? void 0 : contactMapHtml.trim());
  var hasContactFallbackImage = Boolean(contactFallbackImage);
  var hasContactVisual = hasContactMap || hasContactFallbackImage;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationBar, {
      HomePage: true
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (HomePage_module_default()).background,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
          rel: "preconnect",
          href: "https://mu7.ejjadh.info"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
        className: (HomePage_module_default()).banner,
        style: {},
        children: [appSetting !== null && appSetting !== void 0 && (_appSetting$mainBanne = appSetting.mainBannerImage) !== null && _appSetting$mainBanne !== void 0 && _appSetting$mainBanne.includes("mp4") ? /*#__PURE__*/(0,jsx_runtime.jsxs)("video", {
          className: (HomePage_module_default()).videobcg,
          autoPlay: true,
          loop: "loop",
          muted: true // volume="0"
          ,
          preload: "metadata",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
            src: "".concat("https://mu7.ejjadh.info", "/").concat(appSetting.mainBannerImage, "#t=0.1"),
            type: "video/mp4"
          }), "Sorry, your browser does not support HTML5 video."]
        }) : appSetting !== null && appSetting !== void 0 && appSetting.mainBannerImage ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "".concat("https://mu7.ejjadh.info", "/").concat(appSetting.mainBannerImage),
          width: 1920,
          height: 1000,
          alt: "background",
          quality: 75,
          sizes: "100vw",
          priority: true,
          fetchpriority: "high"
        }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
          className: "h-100",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (HomePage_module_default())["background-text"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
              children: [lang === "ar" && (data === null || data === void 0 ? void 0 : (_data$indexData2 = data.indexData) === null || _data$indexData2 === void 0 ? void 0 : (_data$indexData2$AppS = _data$indexData2.AppSetting) === null || _data$indexData2$AppS === void 0 ? void 0 : _data$indexData2$AppS.BannerTitle), lang === "en" && (data === null || data === void 0 ? void 0 : (_data$indexData3 = data.indexData) === null || _data$indexData3 === void 0 ? void 0 : (_data$indexData3$AppS = _data$indexData3.AppSetting) === null || _data$indexData3$AppS === void 0 ? void 0 : _data$indexData3$AppS.BannerTitle_EN)]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
              children: [lang === "ar" && (data === null || data === void 0 ? void 0 : (_data$indexData4 = data.indexData) === null || _data$indexData4 === void 0 ? void 0 : (_data$indexData4$AppS = _data$indexData4.AppSetting) === null || _data$indexData4$AppS === void 0 ? void 0 : _data$indexData4$AppS.BannerDesc), lang === "en" && (data === null || data === void 0 ? void 0 : (_data$indexData5 = data.indexData) === null || _data$indexData5 === void 0 ? void 0 : (_data$indexData5$AppS = _data$indexData5.AppSetting) === null || _data$indexData5$AppS === void 0 ? void 0 : _data$indexData5$AppS.BannerDesc_EN)]
            }), bannerCtaText && bannerCtaUrl ? isExternalBannerCtaUrl ? /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              href: bannerCtaUrl,
              target: "_blank",
              rel: "noreferrer",
              className: (HomePage_module_default())["cta-button"],
              children: [bannerCtaText, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "white",
                  borderRadius: "500px"
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                  style: {
                    transform: isRtl ? "none" : "scaleX(-1)"
                  },
                  width: "18",
                  height: "18",
                  viewBox: "0 0 18 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M3.53577 3.53556L14.1424 14.1422",
                    stroke: "black",
                    strokeWidth: 1.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                    stroke: "black",
                    strokeWidth: 1.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  })]
                })
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: bannerCtaUrl,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: (HomePage_module_default())["cta-button"],
                children: bannerCtaText
              })
            }) : null]
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spliter, {
      primaryTitle: splitersData === null || splitersData === void 0 ? void 0 : (_splitersData$ = splitersData[0]) === null || _splitersData$ === void 0 ? void 0 : (_splitersData$$data = _splitersData$.data) === null || _splitersData$$data === void 0 ? void 0 : (_splitersData$$data$t = _splitersData$$data.title) === null || _splitersData$$data$t === void 0 ? void 0 : _splitersData$$data$t[lang],
      primaryText: splitersData === null || splitersData === void 0 ? void 0 : (_splitersData$2 = splitersData[0]) === null || _splitersData$2 === void 0 ? void 0 : (_splitersData$2$data = _splitersData$2.data) === null || _splitersData$2$data === void 0 ? void 0 : (_splitersData$2$data$ = _splitersData$2$data.description) === null || _splitersData$2$data$ === void 0 ? void 0 : _splitersData$2$data$[lang],
      secondaryTitle: splitersData === null || splitersData === void 0 ? void 0 : (_splitersData$3 = splitersData[0]) === null || _splitersData$3 === void 0 ? void 0 : (_splitersData$3$data = _splitersData$3.data) === null || _splitersData$3$data === void 0 ? void 0 : (_splitersData$3$data$ = _splitersData$3$data.title2) === null || _splitersData$3$data$ === void 0 ? void 0 : _splitersData$3$data$[lang],
      secondaryText: splitersData === null || splitersData === void 0 ? void 0 : (_splitersData$4 = splitersData[0]) === null || _splitersData$4 === void 0 ? void 0 : (_splitersData$4$data = _splitersData$4.data) === null || _splitersData$4$data === void 0 ? void 0 : (_splitersData$4$data$ = _splitersData$4$data.description2) === null || _splitersData$4$data$ === void 0 ? void 0 : _splitersData$4$data$[lang],
      image: splitersData === null || splitersData === void 0 ? void 0 : (_splitersData$5 = splitersData[0]) === null || _splitersData$5 === void 0 ? void 0 : (_splitersData$5$data = _splitersData$5.data) === null || _splitersData$5$data === void 0 ? void 0 : _splitersData$5$data.image
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        backgroundImage: "url(".concat(second_bg/* default.src */.Z.src, ")"),
        backgroundColor: "#F0E3E3"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
        className: (HomePage_module_default())["background-images"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row, {
          className: "px-md-5",
          children: bannerData === null || bannerData === void 0 ? void 0 : bannerData.map(function (post, index) {
            var _post$data, _post$data2, _post$data3, _post$data3$title, _post$data4, _post$data4$descripti;

            var isForcedWhite = index === 0;
            var hasImage = isForcedWhite ? false : post === null || post === void 0 ? void 0 : (_post$data = post.data) === null || _post$data === void 0 ? void 0 : _post$data.image;
            var bgImage = hasImage ? (0,imageHelpers/* buildApiUrl */.f8)(post === null || post === void 0 ? void 0 : (_post$data2 = post.data) === null || _post$data2 === void 0 ? void 0 : _post$data2.image) : null;

            var orders = function orders() {
              var order;
              index === 0 ? order = 2 : index === 1 ? order = 1 : index === 2 ? order = 3 : order = 4;
              return order;
            };

            return /*#__PURE__*/(0,jsx_runtime.jsx)(Col, {
              lg: 6,
              xs: {
                span: 12,
                order: orders()
              },
              className: "p-3",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "".concat((HomePage_module_default())["banner-card"], " ").concat(hasImage ? (HomePage_module_default())["with-image"] : (HomePage_module_default())["without-image"]),
                style: {
                  backgroundImage: bgImage ? "url(".concat(bgImage, ")") : "none"
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (HomePage_module_default())["card-content"],
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                    className: (HomePage_module_default())["card-title"],
                    dangerouslySetInnerHTML: {
                      __html: (post === null || post === void 0 ? void 0 : (_post$data3 = post.data) === null || _post$data3 === void 0 ? void 0 : (_post$data3$title = _post$data3.title) === null || _post$data3$title === void 0 ? void 0 : _post$data3$title[lang]) || ""
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (HomePage_module_default())["card-description"],
                    dangerouslySetInnerHTML: {
                      __html: (post === null || post === void 0 ? void 0 : (_post$data4 = post.data) === null || _post$data4 === void 0 ? void 0 : (_post$data4$descripti = _post$data4.description) === null || _post$data4$descripti === void 0 ? void 0 : _post$data4$descripti[lang]) || ""
                    }
                  })]
                })
              })
            }, index);
          })
        })
      })
    }), (partnerPosts === null || partnerPosts === void 0 ? void 0 : partnerPosts.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (HomePage_module_default()).partners,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (HomePage_module_default()).partnersTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "success-partners"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (HomePage_module_default()).images,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.t, {
            dir: dir,
            modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Pagination */.tl],
            spaceBetween: 20 // loop
            // autoplay={{ delay: 2500, disableOnInteraction: false }}
            ,
            pagination: {
              el: ".".concat((HomePage_module_default())["partners-pagination"]),
              clickable: true
            },
            breakpoints: {
              0: {
                slidesPerView: 2
              },
              576: {
                slidesPerView: 3
              },
              992: {
                slidesPerView: 5
              }
            },
            children: partnerPosts === null || partnerPosts === void 0 ? void 0 : partnerPosts.map(function (post, index) {
              var _post$data5;

              return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                style: {
                  paddingBlock: "20px"
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (HomePage_module_default()).partner,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    width: 120,
                    height: 90,
                    src: (0,imageHelpers/* buildApiUrl */.f8)(post === null || post === void 0 ? void 0 : (_post$data5 = post.data) === null || _post$data5 === void 0 ? void 0 : _post$data5.image),
                    alt: "our-partner-".concat(index),
                    sizes: "100%",
                    layout: "intrinsic",
                    loading: "lazy"
                  })
                })
              }, index);
            })
          }, dir), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (HomePage_module_default())["partners-controls"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (HomePage_module_default())["partners-pagination"]
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PriceList, {
      data: pricesData
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel, {
      footerLinks: data === null || data === void 0 ? void 0 : data.footerLinks,
      posts: (data === null || data === void 0 ? void 0 : (_data$sliderData = data.sliderData) === null || _data$sliderData === void 0 ? void 0 : (_data$sliderData$ = _data$sliderData[0]) === null || _data$sliderData$ === void 0 ? void 0 : (_data$sliderData$$cat = _data$sliderData$.categories) === null || _data$sliderData$$cat === void 0 ? void 0 : (_data$sliderData$$cat2 = _data$sliderData$$cat[0]) === null || _data$sliderData$$cat2 === void 0 ? void 0 : _data$sliderData$$cat2.posts) || []
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BackgroundImageWithTextButtonRightImageLeft, {
      primaryText: lang === "ar" ? indexData === null || indexData === void 0 ? void 0 : indexData.RedTitle : indexData === null || indexData === void 0 ? void 0 : indexData.RedTitle_EN,
      secondaryText: lang === "ar" ? indexData === null || indexData === void 0 ? void 0 : indexData.RedDesc : indexData === null || indexData === void 0 ? void 0 : indexData.RedDesc_EN,
      footerLinks: data === null || data === void 0 ? void 0 : data.footerLinks
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (HomePage_module_default())["white-background"],
      style: {
        backgroundImage: "url(".concat(forth_bg.src, ")")
      },
      dir: lang === "ar" ? "rtl" : "ltr",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
        children: benfitDataPosts === null || benfitDataPosts === void 0 ? void 0 : benfitDataPosts.map(function (post, index) {
          var _post$data6, _post$data7, _post$data7$cta, _post$data8, _post$data9, _post$data9$title, _post$data10, _post$data10$title, _post$data11, _post$data11$subtitle, _post$data12, _post$data12$descript;

          var ctaUrl = normalizeSettingValue(post === null || post === void 0 ? void 0 : (_post$data6 = post.data) === null || _post$data6 === void 0 ? void 0 : _post$data6.ctaUrl);
          var ctaText = post === null || post === void 0 ? void 0 : (_post$data7 = post.data) === null || _post$data7 === void 0 ? void 0 : (_post$data7$cta = _post$data7.cta) === null || _post$data7$cta === void 0 ? void 0 : _post$data7$cta[lang];
          var isExternal = /^https?:\/\//i.test(ctaUrl);
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
            className: "align-items-center gy-5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col, {
              lg: 7,
              xs: 12,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (HomePage_module_default())["white-background__image-box"],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (HomePage_module_default())["image-wrapper"],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: (0,imageHelpers/* buildApiUrl */.f8)(post === null || post === void 0 ? void 0 : (_post$data8 = post.data) === null || _post$data8 === void 0 ? void 0 : _post$data8.bannerImage),
                    alt: (post === null || post === void 0 ? void 0 : (_post$data9 = post.data) === null || _post$data9 === void 0 ? void 0 : (_post$data9$title = _post$data9.title) === null || _post$data9$title === void 0 ? void 0 : _post$data9$title[lang]) || "benefit-image",
                    width: 600,
                    height: 400,
                    layout: "responsive",
                    objectFit: "cover"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col, {
              lg: 5,
              xs: 12,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (HomePage_module_default())["white-background__text"],
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                  dangerouslySetInnerHTML: {
                    __html: (post === null || post === void 0 ? void 0 : (_post$data10 = post.data) === null || _post$data10 === void 0 ? void 0 : (_post$data10$title = _post$data10.title) === null || _post$data10$title === void 0 ? void 0 : _post$data10$title[lang]) || ""
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  dangerouslySetInnerHTML: {
                    __html: (post === null || post === void 0 ? void 0 : (_post$data11 = post.data) === null || _post$data11 === void 0 ? void 0 : (_post$data11$subtitle = _post$data11.subtitle) === null || _post$data11$subtitle === void 0 ? void 0 : _post$data11$subtitle[lang]) || ""
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (HomePage_module_default()).description,
                  dangerouslySetInnerHTML: {
                    __html: (post === null || post === void 0 ? void 0 : (_post$data12 = post.data) === null || _post$data12 === void 0 ? void 0 : (_post$data12$descript = _post$data12.description) === null || _post$data12$descript === void 0 ? void 0 : _post$data12$descript[lang]) || ""
                  }
                }), ctaText && ctaUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mt-4",
                  children: isExternal ? /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                    href: ctaUrl,
                    target: "_blank",
                    rel: "noreferrer",
                    className: (HomePage_module_default())["cta-button-red"],
                    children: [ctaText, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (HomePage_module_default())["icon-circle"],
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                        style: {
                          transform: isRtl ? "none" : "scaleX(-1)"
                        },
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                          d: "M3.53577 3.53556L14.1424 14.1422",
                          stroke: "black",
                          strokeWidth: 1.5,
                          strokeLinecap: "round",
                          strokeLinejoin: "round"
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                          d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                          stroke: "black",
                          strokeWidth: 1.5,
                          strokeLinecap: "round",
                          strokeLinejoin: "round"
                        })]
                      })
                    })]
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: ctaUrl,
                    passHref: true,
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                      className: (HomePage_module_default())["cta-button-red"],
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: (HomePage_module_default())["icon-circle"],
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                          style: {
                            transform: isRtl ? "none" : "scaleX(-1)"
                          },
                          width: "18",
                          height: "18",
                          viewBox: "0 0 18 18",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                            d: "M3.53577 3.53556L14.1424 14.1422",
                            stroke: "black",
                            strokeWidth: 1.5,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                            d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                            stroke: "black",
                            strokeWidth: 1.5,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                          })]
                        })
                      }), ctaText]
                    })
                  })
                })]
              })
            })]
          }, index);
        })
      })
    }), (certificationsItems === null || certificationsItems === void 0 ? void 0 : certificationsItems.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (HomePage_module_default())["certifications-section"],
      dir: lang === "ar" ? "rtl" : "ltr",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (HomePage_module_default())["certifications-title"],
          children: certificationsTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (HomePage_module_default())["certifications-track"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.t, {
            dir: lang === "ar" ? "rtl" : "ltr",
            className: (HomePage_module_default())["certifications-swiper"],
            modules: [swiper_esm/* Pagination */.tl],
            spaceBetween: 16,
            pagination: {
              el: ".".concat((HomePage_module_default())["certifications-pagination"]),
              clickable: true
            },
            breakpoints: {
              0: {
                slidesPerView: 1
              },
              620: {
                slidesPerView: 2
              },
              990: {
                slidesPerView: 3
              }
            },
            children: certificationsItems.map(function (item, index) {
              var _item$value, _item$name, _item$name2;

              var value = item === null || item === void 0 ? void 0 : (_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value[lang];
              var image = item === null || item === void 0 ? void 0 : item.image;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat((HomePage_module_default())["certification-card"], " ").concat(image ? (HomePage_module_default())["certification-card--with-image"] : ""),
                  style: image ? {
                    backgroundImage: "url(".concat((0,imageHelpers/* buildApiUrl */.f8)(image), ")")
                  } : undefined,
                  role: image ? "button" : undefined,
                  tabIndex: image ? 0 : undefined,
                  onClick: image ? function () {
                    return setLightboxImage((0,imageHelpers/* buildApiUrl */.f8)(image));
                  } : undefined,
                  onKeyDown: image ? function (e) {
                    if (e.key === "Enter") setLightboxImage((0,imageHelpers/* buildApiUrl */.f8)(image));
                  } : undefined,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (HomePage_module_default())["certification-card__content"],
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                      children: item === null || item === void 0 ? void 0 : (_item$name2 = item.name) === null || _item$name2 === void 0 ? void 0 : _item$name2[lang]
                    }), value && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: value
                    })]
                  })
                })
              }, "".concat((item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name[lang]) || "certification", "-").concat(index));
            })
          }, lang), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (HomePage_module_default())["certifications-controls"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (HomePage_module_default())["certifications-pagination"]
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal, {
      show: Boolean(lightboxImage),
      onHide: function onHide() {
        return setLightboxImage(null);
      },
      centered: true,
      className: (HomePage_module_default())["certification-lightbox"],
      children: lightboxImage && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (HomePage_module_default())["certification-lightbox__frame"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          className: (HomePage_module_default())["certification-lightbox__close"],
          "aria-label": "close",
          onClick: function onClick() {
            return setLightboxImage(null);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            style: {
              marginBottom: "2px"
            },
            children: "\xD7"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: lightboxImage,
          alt: "certification"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CommonQuestions, {
      commonQuestionsBackgroundImage: commonQuestionsBackgroundImage,
      filteredQuestions: filteredQuestions
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (HomePage_module_default())["home-contact"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
          className: "".concat((HomePage_module_default())["home-contact__row"], " ").concat(!hasContactVisual ? (HomePage_module_default())["home-contact__row--centered"] : ""),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col, {
            lg: hasContactVisual ? 7 : 8,
            xs: 12,
            className: (HomePage_module_default())["home-contact__form-col"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Form["default"], {})
          }), hasContactMap ? /*#__PURE__*/(0,jsx_runtime.jsx)(Col, {
            lg: 5,
            xs: 12,
            className: (HomePage_module_default())["home-contact__visual-col"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "contact-map",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                  __html: contactMapHtml
                }
              })
            })
          }) : hasContactFallbackImage ? /*#__PURE__*/(0,jsx_runtime.jsx)(Col, {
            className: (HomePage_module_default())["home-contact__visual-col"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "contact-map",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: (0,imageHelpers/* buildApiUrl */.f8)(contactFallbackImage),
                alt: lang === "ar" ? "صورة الموقع" : "Location"
              })
            })
          }) : null]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {})]
  });
};

/* harmony default export */ var HomePage_HomePage = (HomePage);

/***/ }),

/***/ 3476:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo.72f176e4.png","height":3264,"width":5016,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAANlBMVEUBAAALAAD3AAALDhALGCAFCw4OGSABAAAOFx4AAADdAQIPFx6xBQjxAAAOGSIRFSIAFxcAGyS2XswHAAAAEnRSTlM7K1sySyGvJ4E4fVJZJp08C3gWJ2qoAAAACXBIWXMAAEzlAABM5QF1zvCVAAAALElEQVR4nAXBhwEAEBAAscNX3f7LSogRcUevbDNrb3ZEj4TUhTdX96IkCUn5HKQBEo69UrAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 292:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/second-bg.d53eab00.png","height":523,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEXe3t7k5OTi4uLo6Oji4uKEqJd8AAAABXRSTlM5Y1NwR+60uYcAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAXSURBVHicY2BgYmBiACFmRmZGRkYmZgAAqAAWu9UqAAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 5115:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__nZmoY","contact-box":"Form_contact-box__bAzAe","text":"Form_text__BgO2i","input-group":"Form_input-group__XpGvF","button-wrapper":"Form_button-wrapper__yhLPu","cta-button-red":"Form_cta-button-red__ze4Fa","icon-circle":"Form_icon-circle__kJ6wB","error-text":"Form_error-text__7YE4D"};

/***/ }),

/***/ 1215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__4PSzu","red":"Button_red__wHc_V","black":"Button_black__4q2Dt","rounded":"Button_rounded__vANJA","squared":"Button_squared__Ct5BB","disabled":"Button_disabled__rRoIJ"};

/***/ }),

/***/ 4471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"HomePage_container__uWenc","cta-button":"HomePage_cta-button__EW5X1","cta-button-white":"HomePage_cta-button-white__aXFqL","flex":"HomePage_flex__DOU_P","flex-col":"HomePage_flex-col__wSQIP","background":"HomePage_background__nbEs0","banner":"HomePage_banner__TbxkH","videobcg":"HomePage_videobcg__gle7k","background-text":"HomePage_background-text__Uh9C8","custom-head":"HomePage_custom-head__MYHKG","background-images":"HomePage_background-images__ccx9D","slideInRight":"HomePage_slideInRight__Ls4fc","banner-card":"HomePage_banner-card__zEW0s","with-image":"HomePage_with-image__qg8Jn","without-image":"HomePage_without-image__G1Dro","card-content":"HomePage_card-content__Q68XL","card-title":"HomePage_card-title__rbdpO","card-description":"HomePage_card-description__uQe5d","white-background":"HomePage_white-background__ntvHk","white-background__text":"HomePage_white-background__text__qnMhx","description":"HomePage_description__mumgd","cta-button-red":"HomePage_cta-button-red__UxmIn","icon-circle":"HomePage_icon-circle__jz8Z8","white-background__image-box":"HomePage_white-background__image-box__MYS0r","image-wrapper":"HomePage_image-wrapper__XjqDd","white-background__banner":"HomePage_white-background__banner__v3opZ","white-background__content":"HomePage_white-background__content__N2NJE","grid-container":"HomePage_grid-container__Dme_K","partners":"HomePage_partners__3fVJR","partnersTitle":"HomePage_partnersTitle__vyG17","images":"HomePage_images__F4jX2","partners-controls":"HomePage_partners-controls__kaYRV","partners-pagination":"HomePage_partners-pagination__D2eeJ","partner":"HomePage_partner__UuUa4","certifications-section":"HomePage_certifications-section__YqU3q","certifications-title":"HomePage_certifications-title__x_lsc","certifications-track":"HomePage_certifications-track__5iyCT","certifications-controls":"HomePage_certifications-controls__X0N_k","certifications-pagination":"HomePage_certifications-pagination__GV1le","certification-card":"HomePage_certification-card__97YNA","certification-card--with-image":"HomePage_certification-card--with-image__TTjUF","certification-card__content":"HomePage_certification-card__content__3JPHx","certification-lightbox":"HomePage_certification-lightbox__LAfLj","certification-lightbox__frame":"HomePage_certification-lightbox__frame__ySq1r","certification-lightbox__close":"HomePage_certification-lightbox__close__UeURr","home-contact":"HomePage_home-contact__TK20t","home-contact__row":"HomePage_home-contact__row__jOyDm","home-contact__row--centered":"HomePage_home-contact__row--centered__RgZM4","home-contact__visual-col":"HomePage_home-contact__visual-col__leb6L","home-contact__form-col":"HomePage_home-contact__form-col__qa6ic"};

/***/ }),

/***/ 8279:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2357:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(7294)):0}(this,(function(e){return(()=>{"use strict";var t={297:t=>{t.exports=e}},n={};function r(e){var o=n[e];if(void 0!==o)return o.exports;var i=n[e]={exports:{}};return t[e](i,i.exports,r),i.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t);var o={};return(()=>{r.d(o,{default:()=>u});var e,t=r(297),n=r.n(t),i=function(){return(i=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)};function c(e,t){return e>t?t:e<0?0:e}function u(r){var o=r.firstImage,u=r.secondImage,a=r.className,f=r.withResizeFeel,s=void 0===f||f,l=r.currentPercentPosition,d=r.onVisible,v=r.onReady,m=r.onChangePercentPosition,p=r.delimiterIconStyles,g=r.feelsOnlyTheDelimiter,E=void 0!==g&&g,h=r.delimiterColor,b=void 0===h?"#fff":h,y=r.onChangeMode,w=["before-after-slider"];a&&w.push(a);var O=(0,t.useRef)(null),L=(0,t.useRef)(null),M=(0,t.useState)(null),R=M[0],x=M[1],S=(0,t.useState)(l||50),_=S[0],C=S[1],j=(0,t.useState)(e.DEFAULT),T=j[0],I=j[1],P=function(e,n,r){var o=(0,t.useState)(!1),i=o[0],c=o[1],u=(0,t.useRef)([!1,!1]);return(0,t.useEffect)((function(){!i&&u.current.every(Boolean)&&e&&n.current&&c(!0)}),[u.current,e,i,n.current]),(0,t.useEffect)((function(){i&&r&&r()}),[i]),{onImageLoad:function(e){var t=function(e,t){for(var n=0,r=t.length,o=e.length;n<r;n++,o++)e[o]=t[n];return e}([],u.current);t[e]=!0,u.current=t},isReady:i}}(R,O,v),B=P.onImageLoad,N=P.isReady,A=(0,t.useState)({top:0,left:0}),D=A[0],F=A[1],U=(0,t.useState)(d&&"undefined"!=typeof window&&Boolean(window.IntersectionObserver)?new IntersectionObserver((function(e){U&&d&&e.forEach((function(e){e.intersectionRatio>.95&&(U.disconnect(),d())}))}),{threshold:[0,.95]}):null)[0];(0,t.useEffect)((function(){if(U){if(!N)return;U.observe(O.current)}}),[N]),(0,t.useEffect)((function(){l&&R&&C(c(l,R))}),[l,R]);var k=function(){if(O.current){var e=O.current.offsetWidth;x(e)}},V=function(){z(e.DEFAULT)},z=function(e){I(e),y&&y(e)};!function(e,n,r,o){(0,t.useEffect)((function(){return e(),r.current&&r.current.complete&&o(0),document.addEventListener("click",n),function(){document.removeEventListener("click",n)}}),[])}(k,V,L,B);var q=R?{width:R+"px"}:void 0,X={width:_+"%"},W=n().useMemo((function(){return i({backgroundColor:b},p||{})}),[b,p]),Y=n().useMemo((function(){return{left:_+"%",backgroundColor:b}}),[_,b]),G=function(){!function(){if(O.current){var e=O.current.getBoundingClientRect();F({top:e.top+pageYOffset,left:e.left+pageXOffset})}}(),z(e.MOVE)},H=function(t){if(T===e.MOVE){if(!R)return;var n=c(t.pageX-D.left,R)/R*100;m?m(n):C(n)}};!function(e,n){(0,t.useEffect)((function(){return n&&window.addEventListener("resize",e),function(){window.removeEventListener("resize",e)}}),[])}(k,s);var J={onMouseDown:G,onTouchStart:G};return n().createElement("div",i({ref:O,className:w.join(" "),onMouseMove:function(e){return H(e)},onTouchMove:function(e){H(e.touches[0])},onTouchEnd:V,onTouchCancel:V},E?{}:J),n().createElement("div",{className:"before-after-slider__first-photo-container"},n().createElement("img",{src:o.imageUrl,onLoad:function(){k(),B(0)},draggable:!1,alt:o.alt,ref:L})),Boolean(R)&&n().createElement(n().Fragment,null,n().createElement("div",{className:"before-after-slider__second-photo-container",style:X},n().createElement("img",{style:q,src:u.imageUrl,onLoad:function(){return B(1)},draggable:!1,alt:u.alt})),n().createElement("div",i({className:"before-after-slider__delimiter",style:Y},E?J:{}),n().createElement("div",null,n().createElement("div",{className:"before-after-slider__delimiter-icon",style:W})))))}!function(e){e.MOVE="move",e.DEFAULT="default"}(e||(e={}))})(),o.default})()}));

/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useCol": function() { return /* binding */ useCol; }
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;
    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["default"] = (Col);

/***/ }),

/***/ 4215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;
    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["default"] = (Row);

/***/ }),

/***/ 4012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _useIntl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(nextProps, ["values"]);
    return ((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(nextValues, values) &&
        (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(otherProps, nextOtherProps));
}
function FormattedMessage(props) {
    var intl = (0,_useIntl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
    }
    if (Component) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(nodes));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = react__WEBPACK_IMPORTED_MODULE_0__.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
/* harmony default export */ __webpack_exports__["Z"] = (MemoizedFormattedMessage);


/***/ }),

/***/ 6896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4806);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ })

}]);